import { FC, useLayoutEffect } from 'react';
import { ANALYTICS_EXPORT_ROOT_CLASS_NAME } from './constants/analyticsExportPageLayout';

export const ANALYTICS_EXPORT_PDF_STYLES_ID = 'analytics-export-pdf-styles';

const analyticsExportPdfPageCss = `
  @page {
    size: A4 landscape;
    margin: 0;
  }
`;

const analyticsExportPdfLayoutCss = `
  body {
    margin: 0;
    background-color: #ffffff;
  }

  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} {
    width: 100%;
  }

  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME},
  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} .analytics-export-page {
    box-sizing: border-box;
  }

  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} .analytics-export-metric-tile,
  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} .analytics-export-post-card {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  /* Chrome drops aspect-ratio when printing, so the media box is fixed. */
  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} .analytics-export-post-card-media {
    height: 52mm;
    overflow: hidden;
  }

  .${ANALYTICS_EXPORT_ROOT_CLASS_NAME} .analytics-export-post-card-caption {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
`;

const AnalyticsExportPdfStyles: FC = () => {
  useLayoutEffect(() => {
    const css = `
      ${analyticsExportPdfPageCss}
      ${analyticsExportPdfLayoutCss}
      @media print {
        ${analyticsExportPdfPageCss}
        ${analyticsExportPdfLayoutCss}
      }
    `;

    let styleElement = document.getElementById(
      ANALYTICS_EXPORT_PDF_STYLES_ID,
    ) as HTMLStyleElement | null;

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = ANALYTICS_EXPORT_PDF_STYLES_ID;
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = css;

    return () => {
      styleElement?.remove();
    };
  }, []);

  return null;
};

export default AnalyticsExportPdfStyles;
